// extracted by css-extract-rspack-plugin
export default {"cls1":"create_work_collection_modal-wjs-cls1_cMv","cls2":"create_work_collection_modal-wjs-cls2_0Wk create_work_collection_modal-wjs-cls1_cMv"};